var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ZyroButton',{staticClass:"publish-button",attrs:{"disabled":_vm.isSiteBeingPublished,"theme":"header","color":"red"},on:{"click":_vm.handlePublish}},[_c('div',{staticClass:"publish-button__content",attrs:{"data-qa":"builder-header-text-publishsite"}},[(_vm.isSiteBeingPublished)?_c('Transition',{attrs:{"name":"fade"}},[_c('ZyroLoader',{staticClass:"publish-button__loader",style:({
					'--size': '20px',
					'--weight': '4px',
					'--border-color': 'var(--accent-two-light)',
					'--color': 'var(--light)'
				})})],1):_vm._e(),_vm._v(" "+_vm._s(_vm.buttonText)+" ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }